const OrderPropertiesWrapper = ({ children }) => {
  return <div className="order-properties-wrapper">{children}</div>;
};

export default OrderPropertiesWrapper;
